import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.625 7.1875L10 12.8125L4.375 7.1875",
  stroke: "#1F2937",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "icon-stroke icon-stroke_arrow-down"
}, null, -1)

import SvgWrapper from '@C/ui/icons/SvgWrapper.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IconArrowDown',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SvgWrapper, {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})